import React from "react";

const FooterLogo = () => (
  <svg
    width="70"
    height="28"
    viewBox="0 0 70 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_356_287)">
      <path
        d="M65.6123 15.9214C65.6123 15.9214 64.0444 13.161 60.0428 13.2698H60.0236C56.022 13.161 54.4541 15.9214 54.4541 15.9214L56.2817 11.8352C57.3687 11.3504 58.6288 11.0931 60.0332 11.0931C61.4376 11.0931 62.7458 11.3504 63.7751 11.7857L65.6316 15.9412"
        fill="#FF6E14"
      />
      <path
        d="M2.40479 15.9115H14.2171V18.1179H0V1.30798H13.9863V3.51434H2.40479V8.3624H12.5819V10.5688H2.40479V15.9115Z"
        fill="white"
      />
      <path
        d="M16.3622 11.4889V1.30798H18.767V11.3009C18.767 14.467 20.3734 16.149 23.3649 16.149H23.7401C26.7316 16.149 28.338 14.467 28.338 11.3009V1.30798H30.7428V11.4889C30.7428 15.6939 28.2707 18.3553 23.5477 18.3553C18.8247 18.3553 16.3622 15.6939 16.3622 11.4889Z"
        fill="white"
      />
      <path
        d="M46.499 1.30798H48.9038V18.1179H45.5852L36.0815 4.06841V18.1179H33.6767V1.30798H36.9953L46.499 15.3575V1.30798Z"
        fill="white"
      />
      <path
        d="M53.4729 18.1179H50.8854L58.5134 1.30798H61.6396L69.258 18.1179H66.5935L60.0332 3.4253L53.4729 18.1179Z"
        fill="white"
      />
      <path
        d="M14.3229 26.4585H15.1213C15.1598 26.9235 15.6311 27.1412 16.1891 27.1412H16.3045C16.9201 27.1412 17.2953 26.9928 17.2953 26.6366C17.2953 26.3794 17.1221 26.2309 16.5161 26.1023L15.8524 25.9737C15.0251 25.8055 14.5153 25.5186 14.5153 24.8161C14.5153 24.0048 15.2849 23.5695 16.2372 23.5695C17.478 23.5695 18.0937 24.1037 18.1514 24.915H17.353C17.3145 24.5391 16.9586 24.2324 16.2852 24.2324H16.1698C15.5927 24.2324 15.2849 24.4401 15.2849 24.7468C15.2849 24.9843 15.4291 25.1129 16.0736 25.2415L16.6893 25.3603C17.5261 25.5285 18.0552 25.855 18.0552 26.5772C18.0552 27.2995 17.3626 27.8041 16.2179 27.8041C15.0251 27.8041 14.371 27.2797 14.3229 26.4585Z"
        fill="white"
      />
      <path
        d="M19.1422 25.6769C19.1422 24.3808 20.0656 23.5497 21.4027 23.5497C22.7397 23.5497 23.6632 24.3808 23.6632 25.6769C23.6632 26.973 22.7301 27.8041 21.4027 27.8041C20.0752 27.8041 19.1422 26.973 19.1422 25.6769ZM21.4604 27.1412C22.2588 27.1412 22.8744 26.597 22.8744 25.6868C22.8744 24.7765 22.2588 24.2324 21.4604 24.2324H21.3449C20.5369 24.2324 19.9309 24.7765 19.9309 25.6868C19.9309 26.597 20.5369 27.1412 21.3449 27.1412H21.4604Z"
        fill="white"
      />
      <path d="M24.8752 27.725V21.9963H25.6543V27.725H24.8752Z" fill="white" />
      <path
        d="M27.1357 26.1914V23.6388H27.9148V26.0035C27.9148 26.7356 28.213 27.1413 28.8864 27.1413H29.0018C29.6848 27.1413 30.3004 26.6169 30.3004 25.7462V23.6487H31.0795V27.7349H30.3004V26.9929C30.0503 27.448 29.5693 27.824 28.7998 27.824C27.7128 27.8042 27.1357 27.171 27.1357 26.1914Z"
        fill="white"
      />
      <path
        d="M34.0807 27.725C33.5228 27.725 33.2053 27.3985 33.2053 26.8246V24.3215H32.1761V23.6388H33.2053V22.313H33.9845V23.6388H35.2638V24.3215H33.9845V26.6861C33.9845 26.9335 34.0614 27.0126 34.3019 27.0126H35.437V27.725H34.0807Z"
        fill="white"
      />
      <path
        d="M36.7164 22.9165V21.9963H37.5917V22.9165H36.7164ZM36.7645 27.725V23.6387H37.5436V27.725H36.7645Z"
        fill="white"
      />
      <path
        d="M38.8903 25.6769C38.8903 24.3808 39.8137 23.5497 41.1508 23.5497C42.4878 23.5497 43.4113 24.3808 43.4113 25.6769C43.4113 26.973 42.4782 27.8041 41.1508 27.8041C39.8233 27.8041 38.8903 26.973 38.8903 25.6769ZM41.2085 27.1412C42.0069 27.1412 42.6225 26.597 42.6225 25.6868C42.6225 24.7765 42.0069 24.2324 41.2085 24.2324H41.0931C40.285 24.2324 39.679 24.7765 39.679 25.6868C39.679 26.597 40.285 27.1412 41.0931 27.1412H41.2085Z"
        fill="white"
      />
      <path
        d="M44.556 27.7249V23.6387H45.3351V24.3214C45.6237 23.8861 46.1047 23.5596 46.8646 23.5596C47.9515 23.5596 48.5672 24.2719 48.5672 25.2415V27.7249H47.788V25.4394C47.788 24.7172 47.4802 24.2324 46.7876 24.2324H46.6722C45.9796 24.2324 45.3351 24.8062 45.3351 25.667V27.7249H44.556Z"
        fill="white"
      />
      <path
        d="M49.6541 26.4585H50.4525C50.491 26.9235 50.9623 27.1412 51.5202 27.1412H51.6357C52.2513 27.1412 52.6264 26.9928 52.6264 26.6366C52.6264 26.3794 52.4533 26.2309 51.8473 26.1023L51.1836 25.9737C50.3563 25.8055 49.8465 25.5186 49.8465 24.8161C49.8465 24.0048 50.616 23.5695 51.5683 23.5695C52.8092 23.5695 53.4248 24.1037 53.4825 24.915H52.6842C52.6457 24.5391 52.2898 24.2324 51.6164 24.2324H51.501C50.9238 24.2324 50.616 24.4401 50.616 24.7468C50.616 24.9843 50.7603 25.1129 51.4048 25.2415L52.0204 25.3603C52.8573 25.5285 53.3863 25.855 53.3863 26.5772C53.3863 27.2995 52.6938 27.8041 51.5491 27.8041C50.3659 27.8041 49.7022 27.2797 49.6541 26.4585Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_356_287">
        <rect width="69.258" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FooterLogo;
